
const GEONAMES_USERNAME = "satinder";

/**
 * Search US ZIP codes by prefix. Returns [{ zip, city, state, stateCode }].
 * `state` is the full name (e.g. "Florida"); `stateCode` is the 2-letter abbr.
 * Empty array on <2 digits, network error, or no results.
 */
export async function searchZips(prefix, limit = 6) {
  const q = String(prefix || "").replace(/\D/g, "");
  if (q.length < 2) return [];

  const url =
    `https://secure.geonames.org/postalCodeSearchJSON` +
    `?postalcode_startsWith=${encodeURIComponent(q)}` +
    `&country=US&maxRows=${limit}&username=${GEONAMES_USERNAME}`;

  try {
    const res = await fetch(url);
    if (!res.ok) return [];
    const data = await res.json();

    // GeoNames reports problems (bad username, web services not enabled,
    // limit exceeded) in a `status` object — surface it so it's obvious.
    if (data?.status) {
      console.warn("GeoNames ZIP search error:", data.status.message);
      return [];
    }

    const rows = data?.postalCodes || [];

    // GeoNames can return the same ZIP more than once — de-dupe by code.
    const seen = new Set();
    const out = [];
    for (const r of rows) {
      if (!r.postalCode || seen.has(r.postalCode)) continue;
      seen.add(r.postalCode);
      out.push({
        zip: r.postalCode,
        city: r.placeName || "",
        state: r.adminName1 || r.adminCode1 || "", // full name, e.g. "Florida"
        stateCode: r.adminCode1 || "", // abbreviation, e.g. "FL"
      });
    }
    return out;
  } catch {
    return [];
  }
}
